var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTelegramLarge = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3034_45102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8467 32C25.6832 32 32.8467 24.8366 32.8467 16C32.8467 7.16344 25.6832 0 16.8467 0C8.01012 0 0.84668 7.16344 0.84668 16C0.84668 24.8366 8.01012 32 16.8467 32Z",
    fill: "url(#paint0_linear_3034_45102)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08904 15.8309C12.7534 13.7988 15.8636 12.459 17.4199 11.8117C21.8633 9.96359 22.7865 9.64255 23.3883 9.63195C23.5207 9.62962 23.8166 9.66242 24.0083 9.81797C24.1702 9.94931 24.2147 10.1267 24.2361 10.2513C24.2574 10.3758 24.2839 10.6595 24.2628 10.8811C24.022 13.4111 22.9801 19.5507 22.4501 22.3843C22.2258 23.5833 21.7842 23.9854 21.3566 24.0247C20.4275 24.1102 19.7219 23.4107 18.822 22.8207C17.4138 21.8976 16.6182 21.323 15.2513 20.4222C13.6716 19.3812 14.6957 18.8091 15.596 17.874C15.8316 17.6293 19.9254 13.9056 20.0047 13.5678C20.0146 13.5256 20.0238 13.3681 19.9302 13.285C19.8366 13.2018 19.6986 13.2303 19.5989 13.2529C19.4577 13.2849 17.2081 14.7718 12.85 17.7136C12.2115 18.1521 11.6331 18.3658 11.1149 18.3546C10.5436 18.3422 9.4447 18.0315 8.62777 17.766C7.62577 17.4403 6.82939 17.2681 6.89874 16.7149C6.93486 16.4268 7.33163 16.1321 8.08904 15.8309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3034_45102",
    x1: 16.8467,
    y1: 0,
    x2: 16.8467,
    y2: 31.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3034_45102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.84668)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelegramLarge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telegram-large.3584e88e.svg";
export { ForwardRef as ReactComponent };